<template>
  <main role="main">
    <section class="text-center">
      <div class="container login">
        <div class="login1">
          <div class="login1a"><img :src="ossUrl+'/img/2021033015194.jpg'" alt=""> 创建机构账号</div>
          <div class="login1b">已有机构账号？
            <span @click="$parent.dialogVisible = true">请登录</span>
          </div>
        </div>
        <div class="login2" v-for="(item,index) in list" :key="index">
          <div class="login2a"><span v-if="item.isZ">*</span>{{item.name}}：</div>
          <div class="login2b">
            <template v-if="item.key!='agencyAdd'">
              <el-input v-model="registered[item.key]" size="small" :type="item.type" :show-password="item.type=='password'" autocomplete="off" :maxlength="30"></el-input>
            </template>
            <template v-else>
              <el-select class="selects" v-model="value.province" placeholder="省份" size="small">
                <el-option v-for="item in options.province" :key="item.id" :label="item.fullname" :value="item.id">
                </el-option>
              </el-select>
              <el-select class="selects" v-model="value.city" placeholder="城市" size="small">
                <el-option v-for="item in options.city" :key="item.id" :label="item.fullname" :value="item.id">
                </el-option>
              </el-select>
              <el-select class="selects" v-model="value.Area" placeholder="区/县" size="small">
                <el-option v-for="item in options.Area" :key="item.id" :label="item.fullname" :value="item.id">
                </el-option>
              </el-select>
            </template>
          </div>
          <div class="login2a">{{item.zhu}}</div>
        </div>
        <el-button class="login3" type="primary" @click="onRegistered">提交注册</el-button>
      </div>
    </section>
  </main>
</template>

<script>
import { setToken } from '@/utils/auth';

export default {
  data() {
    return {
      options: { province: [], city: [], Area: [] },
      value: { province: '', city: '', Area: '' },
      list: [
        { name: '用户名', key: 'userName', zhu: '6-12位英文（区分大小写）、数字', isZ: true, type: "text" },
        { name: '机构名称', key: 'agencyName', zhu: '2-50位，机构名称', isZ: false, type: "text" },
        { name: '真实姓名', key: 'name', zhu: '', isZ: true, type: "text" },
        { name: '邮箱', key: 'email', zhu: '请填写真实有效的邮箱', isZ: false, type: "email" },
        { name: '您的机构地址', key: 'agencyAdd', zhu: '', isZ: true, type: "text" },
        { name: '手机号', key: 'phone', zhu: '请填写11位有效的手机号码', isZ: true, type: "tel" },
        { name: '密码', key: 'password', zhu: '6-12位英文（区分大小写）、数字、字符的组合', isZ: true, type: "password" },
        { name: '确认密码', key: 'password2', zhu: '请再输入一遍上面的密码', isZ: true, type: "password" },
        { name: '微信', key: 'wxCode', zhu: '', isZ: false, type: "text" },
      ],
      registered: { userName: '', agencyName: '', name: '', email: '', agencyAdd: ['', '', ''], agencyAddCode: ['', '', ''], phone: '', password: '', password2: '', wxCode: '' }
    };
  },
  watch: {
    'value.province'() {
      this.sApi('getChildren', { id: this.value.province }).then(res => {
        this.options.city = res.result[0];
        this.options.Area = [];
        this.value.city = '';
        this.value.Area = '';
      })
    },
    'value.city'() {
      if (this.value.city == '') return;
      this.sApi('getChildren', { id: this.value.city }).then(res => {
        this.options.Area = res.result[0];
        this.value.Area = '';
      })
    }
  },
  mounted() {
    this.sApi('getChildren', { id: 0 }).then(res => {
      this.options.province = res.result[0]
    })
  },

  methods: {
    getListName(list, code) {
      if (!code) return "";
      for (let i = 0; i < list.length; i++) { if (list[i].id == code) return list[i].fullname; }
    },
    onRegistered() {
      const { agencyName, email, phone, password, password2, userName, name } = this.registered;
      //验证用户名
      if (userName == "") { this.$message({ message: '请输入用户名', type: 'warning' }); return; }
      var reg = /^(?!^\d+$|^[a-zA-Z]+$)(?:[a-zA-Z\d\W]{6,12})$/;
      if (userName != '' && !reg.test(userName)) { this.$message({ message: '请输入正确的用户名', type: 'warning' }); return; }

      //验证真实姓名
      if (name == "") { this.$message({ message: '请输入真实姓名', type: 'warning' }); return; }

      //验证邮箱
      var reg = /^\w+((.\w+)|(-\w+))@[A-Za-z0-9]+((.|-)[A-Za-z0-9]+).[A-Za-z0-9]+$/;
      if (email != '' && !reg.test(email)) { this.$message({ message: '请输入正确的邮箱地址', type: 'warning' }); return; }

      //验证地址
      if (this.value.province == '') { this.$message({ message: '请选择省份', type: 'warning' }); return; }
      if (this.value.city == '') { this.$message({ message: '请选择城市', type: 'warning' }); return; }
      // if (this.value.Area == '') { this.$message({ message: '请选择区/县', type: 'warning' }); return; }

      const { province, city, Area } = this.options;
      const { province: vprovince, city: vcity, Area: vArea } = this.value;

      this.registered.agencyAdd = this.getListName(province, vprovince) + " " + this.getListName(city, vcity) + " " + this.getListName(Area, vArea);
      this.registered.agencyAddCode = vprovince + "|" + vcity + "|" + vArea;

      //验证手机号
      if (phone == '') { this.$message({ message: '请输入手机号', type: 'warning' }); return; }
      reg = /^1\d{10}$/;
      if (!reg.test(phone)) { this.$message({ message: '请输入正确的手机号', type: 'warning' }); return; }

      //验证密码
      if (password == '') { this.$message({ message: '请输入密码', type: 'warning' }); return; }
      if (password2 == '') { this.$message({ message: '请再次输入密码', type: 'warning' }); return; }
      if (password != password2) { this.$message({ message: '两次输入密码不一致', type: 'warning' }); return; }
      reg = /^(?!^\d+$|^[a-zA-Z]+$)(?:[a-zA-Z\d\W]{6,12})$/;
      if (!reg.test(password)) { this.$message({ message: '密码格式错误', type: 'warning' }); return; }


      //验证机构名称
      if (agencyName != '' && (agencyName.length > 50 || agencyName < 2)) {
        this.$message({ message: '机构名称不符合要求', type: 'warning' }); return;
      }

      this.sApi('onRegistered', this.registered).then(res => {
        if (res.code == 200) {
          setToken(res.message);
          this.$store.commit('setTokenValue', res.message);
          this.$message({ message: '登录成功', type: 'success' });
          this.$router.push({ path: "/" });
        }
        else this.$message({ message: res.message, type: 'warning' });
      })
    }
  }
}
</script>

<style lang="scss">
.login {
  text-align: left;
  color: #333;
  background-color: #fdfbfc;
  padding: 30px;
  border-top: 1px solid #dddddd;
  margin-top: 10px;
  .login1 {
    width: 100%;
    float: left;
    .login1a {
      float: left;
      color: #1789de;
      font-size: 18px;
    }
    .login1b {
      float: right;
      color: #e4737b;
      font-size: 14px;
      span {
        color: #1789de;
        cursor: pointer;
        &:hover {
          color: #0056b3;
        }
      }
    }
  }
  .login2 {
    width: 100%;
    float: left;
    margin-top: 30px;
    .login2a {
      width: calc(50% - 170px);
      float: left;
      line-height: 30px;
      padding: 0 10px;
      &:nth-child(1) {
        text-align: right;
      }
      &:nth-child(3) {
        color: #999;
        font-size: 14px;
      }
      span {
        color: #fe2a57;
        margin-right: 5px;
      }
    }
    .login2b {
      width: 340px;
      float: left;
    }
  }
  .login3 {
    width: 300px;
    margin-left: calc(50% - 150px);
    margin-top: 40px;
  }
  .selects {
    float: left;
    width: 106px;
    margin-left: 10px;
    &:nth-child(1) {
      margin-left: 0;
    }
  }
}
@media (max-width: 768px) {
  .login2a,
  .login2b {
    width: 100% !important;
    text-align: left !important;
  }
}
</style>